module.exports = __webpack_public_path__ + "image-353aa4609134.png";